import { apiUrl } from '../config/api'
import { getCountryLabel } from '../Utils/getCountryLabel'
import i18next from 'i18next'

export async function listSocietysByUser(userId) {
  let params = {
    userId: userId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListSocietiesByUserId')

  return sendReq(params, url)
}

export async function insertSociety(params) {
  params.brandLabel = window.$brand

  let url = apiUrl('InsertSociety')

  return sendReq(params, url)
}

export async function getSocietyById(societyId) {
  let params = { societyId }

  let url = apiUrl('GetSocietyById')
  const society = await sendReq(params, url)

  if (society?.country) {
    society.countryLabel = await getCountryLabel(
      society.country,
      i18next.language
    )
  }

  return society
}

export async function getClientsBySocietyId(societyId) {
  let params = { societyId }

  let url = apiUrl('GetClientsBySocietyId')

  return sendReq(params, url)
}

export async function assignClientToSociety(clientId, societyId) {
  let url = apiUrl('AssignClientToSociety')
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({ clientId, societyId })
  }).then((res) => res.json())
}

export async function removeClientFromSociety(clientId, societyId) {
  let url = apiUrl('RemoveClientFromSociety')
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({ clientId, societyId })
  }).then((res) => res.json())
}

export async function listClients(brandLabel = window.$brand) {
  let params = { brandLabel }
  let url = apiUrl('ListClients')
  return sendReq(params, url)
}

export async function listSocietiesByClientId(clientId) {
  let params = { clientId }
  let url = apiUrl('ListSocietiesByClientId')
  return sendReq(params, url)
}

export async function listSocieties() {
  let params = { brandLabel: window.$brand }
  let url = apiUrl('ListSocieties')
  return sendReq(params, url)
}

export async function updateSociety(params) {
  params.brandLabel = window.$brand
  let url = apiUrl('UpdateSociety')
  return sendReqAllowEmpty(params, url)
}

export async function deleteSociety(params) {
  params.brandLabel = window.$brand
  let url = apiUrl('DeleteSociety')
  return sendReqAllowEmpty(params, url)
}

async function sendReqAllowEmpty(params, url) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))
  if (!res) return null
  const text = await res.text()
  return text ? JSON.parse(text) : { status: res.status }
}

async function sendReq(params, url) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))
  return res.json()
}
